import type { ValueOf } from '@weft/utils';

export const PRODUCT_TYPES = {
  FIXED: 'Fixed',
  USAGE: 'Usage',
} as const;

export type ProductType = ValueOf<typeof PRODUCT_TYPES>;